import React, { useState } from 'react';
import { MedicationFormProps } from './Form';
import FDASearchForm, { FDASearchFormValue } from './FDASearchForm';
import MedicationForm from './Form';

export type MaybeFDAInputGateOwnProps = {};

export type MaybeFDAInputGateProps = MaybeFDAInputGateOwnProps & MedicationFormProps;

const MaybeFDAInputGate: React.FC<MaybeFDAInputGateProps> = (props) => {
    const [fdaSearchFormValue, setFDASearchFormValue] = useState<FDASearchFormValue | null>(null);
    const [isShowingFDASearch, setIsShowingFDASearch] = useState(!props.defaultResource);

    if (isShowingFDASearch) {
        return (
            <FDASearchForm
                onSkip={() => setIsShowingFDASearch(false)}
                onComplete={(searchValue) => {
                    setIsShowingFDASearch(false);
                    setFDASearchFormValue(searchValue);
                }}
            />
        );
    } else {
        return <MedicationForm {...props} fdaSearchValue={fdaSearchFormValue || undefined} />;
    }
};

export default React.memo(MaybeFDAInputGate);
